import React from 'react';
import { useNavigate } from 'react-router-dom';

function BookingReviewError({ errorMessage, onRetry, onSignIn, source, searchQuery, fbUrl }) {
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (fbUrl) {
      // If we have a full encoded fallback URL, use it (handles search results with all filters)
      if (fbUrl.startsWith('http')) {
        window.location.href = fbUrl;
      } else {
        navigate(fbUrl);
      }
    } else if (source === "search") {
      // Semi-fallback: use the search page with basic query
      navigate(`/search-form${searchQuery || ""}`);
    } else {
      // Dead-fallback: homepage
      navigate("/");
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-sm p-8 text-center">
        {/* Error Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center">
            <svg className="w-12 h-12 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
        </div>

        <h1 className="text-2xl font-bold text-gray-900 mb-3">
          Unable to Load Booking Details
        </h1>

        <p className="text-gray-600 mb-6">
          {errorMessage || "We couldn't retrieve the booking information. Please try again."}
        </p>

        {/* Action Buttons */}
        <div className="space-y-3">
          {onSignIn ? (
            <button
              onClick={onSignIn}
              className="w-full px-6 py-3 bg-orange-500 hover:bg-orange-600 text-white rounded-lg font-medium transition-colors"
            >
              Sign In
            </button>
          ) : (
            onRetry && (
              <button
                onClick={onRetry}
                className="w-full px-6 py-3 bg-orange-500 hover:bg-orange-600 text-white rounded-lg font-medium transition-colors"
              >
                Try Again
              </button>
            )
          )}

          <button
            onClick={handleGoBack}
            className="w-full px-6 py-3 border border-gray-300 hover:bg-gray-50 text-gray-700 rounded-lg font-medium transition-colors"
          >
            Go Back
          </button>
          {/* 
          <button
            className="w-full px-6 py-3 text-orange-500 hover:text-orange-600 font-medium transition-colors"
          >
            Contact Support
          </button> */}
        </div>
      </div>
    </div>
  );
}

export default BookingReviewError;
